import React from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";

function AddDocumentButton({
  t,
  onChange,
  loading,
  light,
  fileSelected,
  fileName
}) {
  const className = light ? "file-white" : "file-okcomply-blue";

  return (
    <div className={className}>
      <label className="file-label">
        <input
          className="file-input"
          disabled={loading}
          onChange={onChange}
          type="file"
          name="resume"
        />
        <span className="file-cta">
          {!loading && (
            <span className="file-icon">
              <i className="fas fa-upload" />
            </span>
          )}
          <span className="file-label">
            {loading
              ? t("upload.transmitting.label")
              : fileSelected
                ? fileName
                : t("upload.add.label")}
          </span>
        </span>
      </label>
    </div>
  );
}

AddDocumentButton.propTypes = {
  t: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  fileSelected: PropTypes.bool,
  fileName: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  light: PropTypes.bool
};

export default withTranslation()(AddDocumentButton);
